<template>
  <div>
    <el-drawer
      v-if="visible"
      visible
      :title="title"
      direction="rtl"
      :size="1000"
      :before-close="() => $refs.main.cancel()"
      @close="close()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :disabled="disabled"
          :expoMeetingCode="expoMeetingCode"
          :expoInfoCode="expoInfoCode"
          @close="close()"
          @reload="$emit('reload')"
        />
      </div>
      <div class="drawer-footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ this.$l('btn_cancel') }}
        </el-button>
        <el-button
          v-if="!disabled"
          type="primary"
          size="small"
          @click="$refs.main.save()"
        >
          {{ $l('btn_save') }}
        </el-button>
        <el-button
          v-if="type == 'confirm'"
          type="success"
          size="small"
          @click="confirm()"
        >
          {{ $l('btn_confirm') }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { Main },
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' },
    expoMeetingCode: { type: String, default: '' },
    expoInfoCode: { type: String, default: '' },
  },
  computed: {
    disabled() {
      return ['detail', 'confirm'].includes(this.type)
    },
    titleMap() {
      return {
        add: this.$l('dialog_title_add') || '新增会议信息',
        edit: this.$l('dialog_title_edit') || '编辑会议信息',
        detail: this.$l('dialog_title_detail') || '查看会议信息',
        confirm: this.$l('dialog_title_confirm') || '确认会议信息',
      }
    },
    title() {
      return this.titleMap[this.type] || ''
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    async confirm() {
      const confirm = await this.$confirm(
        this.$l('tips_confirmMeeting'),
        this.$l('tips_confirmInfo'),
        {
          confirmButtonText: this.$l('btn_confirm'),
          cancelButtonText: this.$l('btn_cancel'),
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .expoMeetingConfirmApi({ expoMeetingCode: this.expoMeetingCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_confirm_no') || '确认失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_confirm_ok') || '确认成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 32px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
